<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：店铺类型列表 -->
      <el-col :span="4">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleShopTypeSelect('')"
              :class="{ 'selected': selectedShopTypeId === '' }">
              全部
            </li>
            <li v-for="(item, index) in shopTypes" :key="index"
              @click="handleShopTypeSelect(item.shopTypeId)"
              :class="{ 'selected': selectedShopTypeId === item.shopTypeId }">
              {{ item.typeName }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：服务费设置表格 -->
      <el-col :span="20">
        <!-- 查询条件 -->
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('shopServiceRule.queryCondition') }}</div>
          </div>
          <div class="">
            <el-form :inline="true" :model="serviceRuleInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-input v-model="serviceRuleInfo.conditions.typeName"
                  :placeholder="$t('shopServiceRule.inputTypeName')" clearable />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="_queryServiceRuleMethod">
                  <i class="el-icon-search"></i> {{ $t('common.query') }}
                </el-button>
                <el-button type="primary" size="small" @click="_resetServiceRuleMethod">
                  <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <!-- 服务费设置表格 -->
        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('shopServiceRule.serviceFeeRule') }}</div>
            <el-button type="primary" size="small" @click="_openAddServiceRuleModal">
              <i class="el-icon-plus"></i> {{ $t('common.add') }}
            </el-button>
          </div>
          <div class="">
            <el-table :data="serviceRuleInfo.serviceRules" border style="width: 100%">
              <el-table-column prop="typeName" :label="$t('shopServiceRule.typeName')" align="center" />
              <el-table-column prop="serviceFee" :label="$t('shopServiceRule.serviceFee')" align="center">
                <template slot-scope="scope">
                  {{ formatPercent(scope.row.serviceFee) }}
                </template>
              </el-table-column>
              <el-table-column prop="communityFee" :label="$t('shopServiceRule.communityFee')" align="center">
                <template slot-scope="scope">
                  {{ formatPercent(scope.row.communityFee) }}
                </template>
              </el-table-column>
              <el-table-column prop="profitFee" :label="$t('shopServiceRule.profitFee')" align="center">
                <template slot-scope="scope">
                  {{ formatPercent(scope.row.profitFee) }}
                </template>
              </el-table-column>
              <el-table-column prop="remark" :label="$t('shopServiceRule.remark')" align="center" />
              <el-table-column prop="createTime" :label="$t('shopServiceRule.createTime')" align="center" />
              <el-table-column :label="$t('common.operation')" align="center" width="200">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="_openEditServiceRuleModel(scope.row)">
                    {{ $t('common.edit') }}
                  </el-button>
                  <el-button type="text" size="small" @click="_openDeleteServiceRuleModel(scope.row)">
                    {{ $t('common.delete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination @current-change="handleCurrentChange" :current-page="serviceRuleInfo.conditions.page"
              :page-size="serviceRuleInfo.conditions.row" layout="total, prev, pager, next"
              :total="serviceRuleInfo.total" />
          </div>
        </el-card>
      </el-col>
    </el-row>

    <add-service-rule ref="addServiceRule" @refresh="_queryServiceRuleMethod" />
    <edit-service-rule ref="editServiceRule" @refresh="_queryServiceRuleMethod" />
  </div>
</template>

<script>
import { queryShopType } from '@/api/admin/shopTypeApi'
import { queryShopServiceRule, deleteShopServiceRule } from '@/api/shop/shopServiceRuleApi'
import AddServiceRule from '@/components/shop/addServiceRule/addServiceRule.vue'
import EditServiceRule from '@/components/shop/editServiceRule/editServiceRule.vue'

export default {
  name: 'ShopServiceRule',
  components: {
    AddServiceRule,
    EditServiceRule
  },
  data() {
    return {
      shopTypes: [],
      selectedShopTypeId: '',
      serviceRuleInfo: {
        serviceRules: [],
        total: 0,
        conditions: {
          shopTypeId: '',
          typeName: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initData()
  },
  methods: {
    async _initData() {
      await this._listShopTypes()
      await this._listServiceRules(1, 10)
    },
    async _listShopTypes() {
      try {
        const res = await queryShopType({
          page: 1,
          row: 100,
          statusCd: '0'
        })
        this.shopTypes = res.data || []
      } catch (error) {
        console.error('获取店铺类型列表失败:', error)
      }
    },
    async _listServiceRules(page, rows) {
      this.serviceRuleInfo.conditions.page = page
      this.serviceRuleInfo.conditions.row = rows

      const params = {
        ...this.serviceRuleInfo.conditions,
        typeName: this.serviceRuleInfo.conditions.typeName ? this.serviceRuleInfo.conditions.typeName.trim() : '',
        statusCd: '0'
      }

      try {
        const res = await queryShopServiceRule(params)
        this.serviceRuleInfo.total = res.total
        this.serviceRuleInfo.serviceRules = res.data || []
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    handleCurrentChange(val) {
      this._listServiceRules(val, this.serviceRuleInfo.conditions.row)
    },
    handleShopTypeSelect(shopTypeId) {
      this.selectedShopTypeId = shopTypeId
      this.serviceRuleInfo.conditions.shopTypeId = shopTypeId
      this.serviceRuleInfo.conditions.page = 1
      this._listServiceRules(1, this.serviceRuleInfo.conditions.row)
    },
    _openAddServiceRuleModal() {
      if (!this.selectedShopTypeId) {
        this.$message.warning('请先选择店铺类型')
        return
      }
      const selectedType = this.shopTypes.find(type => type.shopTypeId === this.selectedShopTypeId)
      this.$refs.addServiceRule.open({
        shopTypeId: this.selectedShopTypeId,
        typeName: selectedType ? selectedType.typeName : ''
      })
    },
    _openEditServiceRuleModel(row) {
      this.$refs.editServiceRule.open(row)
    },
    async _openDeleteServiceRuleModel(row) {
      try {
        await this.$confirm('确定要删除该服务费设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const res = await deleteShopServiceRule({ ssrId: row.ssrId })
        if (res.code === 0) {
          this.$message.success('删除成功')
          this._queryServiceRuleMethod()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }
    },
    _queryServiceRuleMethod() {
      this._listServiceRules(1, this.serviceRuleInfo.conditions.row)
    },
    _resetServiceRuleMethod() {
      this.serviceRuleInfo.conditions.typeName = ''
      this._listServiceRules(1, this.serviceRuleInfo.conditions.row)
    },
    formatPercent(value) {
      if (!value) return '0.0000%'
      return parseFloat(value).toFixed(4) + '%'
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.margin-top-sm {
  margin-top: 20px;
}

/* 使用全局 list-selector 样式 */
</style>
